import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const LinkExpiredStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;
  min-height: 500px;
  height: calc(100% - 60px);
  background-color: white;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 9px ${VARIABLES.COLORS.SHADOW_2};

  /* Child element styles
  ------------------------------- */
  .activate-wrapper {
    width: calc(450px + ((100% - 640px) / 2));
    text-align: center;
    margin: 0 0 0 auto;
    flex-wrap: wrap;
    padding-right: 10%;
  }

  .notification {
    font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
    color: ${VARIABLES.COLORS.GRAY_3};
    margin-bottom: 40px;
  }

  .activate-form {
    width: 100%;
    max-width: 320px;
    flex-wrap: wrap;
    margin-bottom: 100px;

    .input-control {
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }
    }

    .invalid-message {
      color: ${VARIABLES.COLORS.RED_1};
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
    }

    .button {
      margin-top: 36px;
      &.link {
        margin-top: 14px;
        width: 100%;
      }
    }
  }

  .reminding {
    display: inline-block;
    text-align: center;
    padding: 15px 10%;
    margin-bottom: 15vh;
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
